// TODO: Tech Debt - When we updated the test/transform_event_with_playbook to take an optional pipelineFilter
// we also should have updated it to make the playbookParam optional because you could have a pipeline with
// just a filter and not also a transform. Currently, the endpoint still requires the playbook so this is a
// default playbook to prevent validation errors but should be deleted once the endpoint is updated.
const DEFAULT_PLAYBOOK = {
  version: 'v0.1.0',
  modes: [],
  params: [],
  global: {
    mappings: [],
    filters: [],
    enrichments: [],
    spreadings: [],
    expressions: [
      {
        lang: 'lua',
        body: 'return input\n',
        name: '',
      },
    ],
  },
  default: {
    mappings: [],
    filters: [],
    enrichments: [],
    spreadings: [],
    expressions: [],
  },
  author: '',
};

export default DEFAULT_PLAYBOOK;
